// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalHeader-root-a17d08b2a60bf3755d276bf5ce4fc871"};